import { render, staticRenderFns } from "./ObjectPermissionsModal.vue?vue&type=template&id=fa338ca2"
import script from "./ObjectPermissionsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ObjectPermissionsModal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports